import React from 'react';
import { motion } from 'framer-motion';

const SocialProofBar = () => {
  const platforms = [
    { name: 'Shopify', gradient: 'from-green-600 to-green-500' },
    { name: 'WooCommerce', gradient: 'from-purple-600 to-purple-500' },
    { name: 'Magento', gradient: 'from-orange-600 to-orange-500' },
    { name: 'BigCommerce', gradient: 'from-blue-600 to-blue-500' }
  ];

  return (
    <section className="bg-gray-50 py-12 border-b border-gray-200">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-gray-600 font-medium text-sm mb-8 tracking-wide uppercase">
            TRUSTED BY SHOPIFY & WOOCOMMERCE STORES WORLDWIDE
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            {platforms.map((platform, index) => (
              <motion.div
                key={platform.name}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{ scale: 1.1 }}
                className={`px-6 py-3 rounded-lg bg-gradient-to-r ${platform.gradient} text-white font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300`}
              >
                {platform.name}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofBar;